/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerAdvertiser} from '../api'

export const useMutationRegisterAdvertiser = createReactQueryMutationHook('registerAdvertiser', registerAdvertiser)
